<template>
  <v-layout>
    <v-col class="shrink">
      <v-avatar size="40" v-if="iconExists">
        <img :src="webpage.icon" alt="site logo" @error="iconExists = false" />
      </v-avatar>
    </v-col>
    <v-layout column class="site-info">
      <v-col class="font-weight-bold px-0 pt-2 pb-0">{{ webpage.title }}</v-col>
      <div class="caption px-0 pt-1 pb-0 truncate">
        <a @click.stop :href="webpage.url" target="_blank">{{ webpage.url }}</a>
      </div>
      <v-col class="caption px-0 pt-1 pb-0">
        {{ webpage.provider }} |
        <v-icon x-small>label</v-icon>
        <template v-for="tag in tags">
          {{ tag.text }}
        </template>
      </v-col>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  props: {
    resource: { default: () => ({}) },
    webpage: { default: () => ({}) }
  },
  data() {
    return {
      iconExists: true
    };
  },
  computed: {
    tags() {
      return this.resource.tags.userDefined;
    }
  },
  methods: {}
};
</script>

<style>
.site-info div {
  line-height: 1.3 !important;
}
</style>
